import React from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';
import ItemsCategoryListPage from './items-by-category';
import PageHeaderText from 'components/base/page-header-text';

const ItemsIndex = () => {
  const { permissions } = useDashboardContext();
  const canAccessMeals = permissions.canAccessMeals;
  if (!canAccessMeals) return <AccessDenied />;
  return (
    <div>
      <PageHeaderText
        title='Manage Items'
        description='Manage item categories for each brand on FC Shop'
      />
      <ItemsCategoryListPage />
    </div>
  );
};

export default ItemsIndex;
